import * as React from 'react';
import { useUnreadNotifications } from 'hooks/useUnreadNotifications';
import Bell from 'svg/Bell';
import { ButtonText } from 'components/Button';

interface Props {
  className?: string;
  onClick: () => void;
}

const NotificationIndicator: React.FC<Props> = ({ className, onClick }) => {
  const { unreadCount } = useUnreadNotifications();

  return (
    <div className="relative flex shrink-0 items-center justify-end text-base">
      <ButtonText className="flex items-center justify-center rounded-full" onClick={onClick}>
        <Bell className={className} />
        {unreadCount > 0 && (
          <div className="absolute right-0.5 top-0 h-2 w-2 rounded-full bg-color-bg-lightmode-brand dark:bg-color-bg-darkmode-brand">
            &nbsp;
          </div>
        )}
      </ButtonText>
    </div>
  );
};

export default NotificationIndicator;
